var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5708C2.45 18.5708 1.97917 18.375 1.5875 17.9833C1.19583 17.5916 1 17.1208 1 16.5708V3.5708H0V1.5708H5V0.570801H11V1.5708H16V3.5708H15V16.5708C15 17.1208 14.8042 17.5916 14.4125 17.9833C14.0208 18.375 13.55 18.5708 13 18.5708H3ZM13 3.5708H3V16.5708H13V3.5708ZM5 14.5708H7V5.5708H5V14.5708ZM9 14.5708H11V5.5708H9V14.5708Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4bda26d44d092c83094c1cf67694b41c.svg";
export { ForwardRef as ReactComponent };